import { Subscription } from "rxjs/Subscription";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { BillTypeService } from "../../shared/bill/bill-type.service";
import { LoaderService } from "../../shared/services/loader.service";
import { AccountService } from "./../../shared/account/account.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operator/debounceTime";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../shared/services/auth.service";
import { BackendService } from "../../shared/services/backend.service";
import { ReminderService } from "../../shared/services/reminder/reminder.service";
import { Reminder } from "../../shared/services/reminder/reminder";
import { Constants } from "../../helper/constants";

@Component({
  selector: "app-reminders",
  templateUrl: "./reminders.component.html",
  styleUrls: ["./reminders.component.css"]
})
export class RemindersComponent implements OnInit, OnDestroy {
  private _alert = new Subject<string>();
  formIsCollapsed = true;
  communityId: string;
  userId: string;
  page = 1;
  reminder: Reminder;
  rollout_time: string;
  successMessage: string;
  errorMessage: string;
  subscription: Subscription;
  confirmationMessage;
  confirmationTitle;
  modalReference: NgbModalRef;
  selectedReminder = "";
  reminders: Array<Reminder>;
  activeRouteIndex: number;
  routeSubscription: Subscription = new Subscription();
  billTypeSubscription$: Subscription;
  reminderSubscription$: Subscription = new Subscription();

  constructor(
    private billTypeService: BillTypeService,
    private accountService: AccountService,
    private loaderService: LoaderService,
    private modalService: NgbModal,
    private authService: AuthService,
    private reminderService: ReminderService,
    private route: ActivatedRoute
  ) {
    this.reminder = new Reminder();
    this.rollout_time = Constants.REMINDER_ROLLOUT_TIME;
    this.userId = BackendService.generateUserId(this.authService.getAuthState().email);
  }

  ngOnInit(): void {
    this.routeSubscription = this.accountService.getProfile(this.userId).subscribe((profile: any) => {
      this.route.params.subscribe(params => {
        this.activeRouteIndex = +params.index;
        const activeRole: any = profile.roles[this.activeRouteIndex];

        this.communityId = activeRole.communityId;

        this.billTypeSubscription$ = this.billTypeService.getCommunityBillTypes(this.communityId);

        this.reminderSubscription$ = this.reminderService.getReminders(this.communityId).subscribe(data => {
          this.reminders = data;
        });
      });
    });
  }

  openCreateForm(): void {
    this.resetFormFields();
    this.formIsCollapsed = false;
  }

  saveReminder(): void {
    if (this.reminders.length) {
      for (const i of this.reminders) {
        if (i.serviceId === this.reminder.serviceId) {
          this.showAlert(false, "A reminder has already been set for this bill.");

          return;
        }
      }
    }

    this.reminder.createdAt = Date.now();
    this.reminder.operatorId = this.userId;
    this.reminderService.create(this.communityId, this.reminder);
    this.showAlert(true, "Reminder saved successfully.");
    this.resetFormFields();
    this.formIsCollapsed = true;
  }

  editReminder(reminder): void {
    this.reminder.id = reminder.id;
    this.reminder.serviceId = reminder.serviceId;
    this.reminder.currentRollOutDay = reminder.currentRollOutDay;
    this.reminder.outstandingRollOutDay = reminder.outstandingRollOutDay;
    this.formIsCollapsed = false;
  }

  updateReminder(): void {
    this.reminder.updatedAt = Date.now();
    this.loaderService.startLoader();
    this.reminderService.update(this.communityId, this.reminder);
    this.formIsCollapsed = true;
    this.showAlert(true, "Bill type updated successfully.");
    this.loaderService.stopLoader();
  }

  confirmDelete(id, modal): void {
    this.selectedReminder = id;
    const message = "Are you sure you want to delete this reminder?";
    this.confirm("Warning!", message, modal);
  }

  proceed(): void {
    if (this.selectedReminder !== "") {
      this.reminderService.delete(this.communityId, this.selectedReminder);
      this.showAlert(true, "Reminder deleted successfully.");
      this.selectedReminder = "";
    }
    this.close();
  }

  resetFormFields(): void {
    this.reminder = new Reminder();
  }

  showAlert(msgType, msg): void {
    this.subscription = this._alert.subscribe(
      message => (msgType ? (this.successMessage = message) : (this.errorMessage = message))
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(() => (msgType ? (this.successMessage = undefined) : (this.errorMessage = undefined)));
    this._alert.next(msg);
    this.subscription.unsubscribe();
  }

  confirm(title, message, modal): void {
    this.confirmationTitle = title;
    this.confirmationMessage = message;
    this.openModal(modal, "sm");
  }

  openModal(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  close(): void {
    this.modalReference.close();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.reminderSubscription$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/reminders/reminders.component.ts